import { useState, useEffect, memo } from "react";
import style from "./../index.module.scss";
import styleUi from "./Charity.module.scss";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import CheckIcon from '@mui/icons-material/Check';

const Charity = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);

    useEffect(() => {
        setInProp(true);
        document.title = "公益";
    }, []);

    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "Charity"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.headerBar}>
                                    <img src="./assets/ui/back.png" onClick={() => setInProp(false)} />
                                    <YStyled.Span size={17} fontWeight={700}>公益</YStyled.Span>
                                    <img src="./assets/ui/back.png" />
                                </div>
                                <div className={styleUi.view}>
                                    <YStyled.Label style={{ width: "100%", height: "auto" }}>
                                        <YStyled.Col gap=".5rem">
                                            <YStyled.Span style={{ alignSelf: "center" }} size={17}>公益活動紀錄</YStyled.Span>
                                            <iframe width="100%" style={{ borderRadius: "6px" }} src="https://www.youtube.com/embed/Z7ftRiib_s4" title="「上玉山才30幾， 下山已經65歲了」登上3858公尺氣象站，最後一次值班｜【誰來晚餐15-22】 Guess Who: A Journey Home from 3858 Meters" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                        </YStyled.Col>
                                    </YStyled.Label>

                                    <YStyled.Label style={{ width: "100%", height: "auto" }}>
                                        <YStyled.Col gap=".5rem">
                                            <YStyled.Span style={{ alignSelf: "center" }} size={17}>OOSA 回饋紀錄</YStyled.Span>
                                            <table border="1" className={styleUi.customTable}>
                                                <tr>
                                                    <td colspan="2">
                                                        <YStyled.Span size={13}>家扶基金會</YStyled.Span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><YStyled.Span size={13}>野外活動 ft. Tommy and his friends</YStyled.Span></td>
                                                    <td><YStyled.Span size={13}>2024.09.10</YStyled.Span></td>
                                                </tr>
                                            </table>
                                        </YStyled.Col>
                                    </YStyled.Label>

                                    <YStyled.Label style={{ width: "100%", height: "auto" }}>
                                        <YStyled.Col gap=".5rem">
                                            <YStyled.Span style={{ alignSelf: "center" }} size={17}>OOSA 回饋紀錄</YStyled.Span>
                                            <table border="1" className={styleUi.customTable}>
                                                <tr>
                                                    <td colspan="2">
                                                        <YStyled.Span size={13}>回饋單位名稱</YStyled.Span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><YStyled.Span size={13}>回饋項目1</YStyled.Span></td>
                                                    <td><YStyled.Span size={13}>回饋日期</YStyled.Span></td>
                                                </tr>
                                                <tr>
                                                    <td><YStyled.Span size={13}>回饋項目2</YStyled.Span></td>
                                                    <td><YStyled.Span size={13}>回饋日期</YStyled.Span></td>
                                                </tr>
                                            </table>
                                        </YStyled.Col>
                                    </YStyled.Label>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(Charity);
